export const ALL_CATEGORIES = [
    'CMP:analytics',
    'CMP:marketing',
    'CMP:advertising',
    'CMP:personalisation',
    // NOTE: this category doesn't exist among the categories the user can
    // actually consent to at the moment. Ignore for now.
    // 'CMP:performance_marketing',
];
